import React from "react";
import { THead, TR, TH } from "../styledEdit";
import Col from "./Col";

const Cols = ({ cols, setSettingsDraft, addCol, removeCol }) => {
  return (
    <>
      <colgroup>
        <col style={{ width: "40px" }} />
        {cols.map((col) => (
          <col key={`col_${col.id}`} style={{ width: `${col.width}%` }} />
        ))}
      </colgroup>
      <THead>
        <TR>
          <TH />
          {cols.map((col, colIdx) => (
            <TH key={col.id} isHidden={col?.hidden}>
              <Col
                colIdx={colIdx}
                col={col}
                setSettingsDraft={setSettingsDraft}
                addCol={addCol}
                removeCol={removeCol}
              />
            </TH>
          ))}
        </TR>
      </THead>
    </>
  );
};

export default Cols;
